import * as React from 'react'
import styled from 'react-emotion'
import BarSvg from './BarSvg'
import ApiSvg from './ApiSvg'
import SurveySvg from './SurveySvg'
import { Row } from 'styleguide'
const padding = '40px'

const Background = styled(Row)`
  z-index: 1;
  position: absolute;
  width: auto;
  top: ${padding};
  left: ${padding};
  right: ${padding};
  bottom: ${padding};
`

const Svg = ({ name }) => {
  return name === 'bar' ? (
    <BarSvg />
  ) : name === 'api' ? (
    <ApiSvg />
  ) : (
    <SurveySvg />
  )
}

export default ({ bg, ...props }) => (
  <Background {...props}>
    <Svg name={bg} />
  </Background>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Background/index.js